import { Modal } from "antd";
import { Button } from "@mui/material";
import { useContext } from "react";
import MainContext from "../../../context/mainContext";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import SaveIcon from "@mui/icons-material/Save";
import TranslateIcon from "@mui/icons-material/Translate";
import {
  saveWordApi,
  deleteWordsByWordApi,
} from "../../../services/userSaveWordApi";
import {
  customToastify,
  checkErrorMessage,
} from "../../pages/utils/utilsFunctions";
import "./modal.css";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import AccordianData from "./AccordianData";
import IconButton from "@mui/material/IconButton";
import Bamooz from "../../../assets/dictIcons/Bamooz.png";
import Fastdic from "../../../assets/dictIcons/Fastdic.png";
import abadis from "../../../assets/dictIcons/abadis.svg";
import bing from "../../../assets/dictIcons/bing.png";
import cambridge from "../../../assets/dictIcons/cambridge.png";
import collins from "../../../assets/dictIcons/collins.png";
import deepl from "../../../assets/dictIcons/deepl.svg";
import glosbe from "../../../assets/dictIcons/glosbe.png";
import google from "../../../assets/dictIcons/google.png";

const SaveAsWordsDialog = (props) => {
  const {
    paperComponent,
    openSaveAsWordsDialog,
    handleOpenSaveAsWordsDialog,
    dict,
    enDataDict,
    translateWord,
    typeWord,
    handleFullScreen,
    handlePlayingStatus,
  } = props;
  const {
    videoInfo,
    subtitleOneContenet,
    subtitleTwoContenet,
    userWords,
    handleUserWords,
    userTypes,
  } = useContext(MainContext);

  const [word, setWord] = useState(translateWord || []);
  const [wordMeinings, setWordMeinings] = useState("-");
  const [fullscreen, setFullscreen] = useState(true);
  const [windowSize, setWindowSize] = useState({
    top: "25%",
    width: "50%",
    lines: 7,
    topLines: 1,
  });

  const saveCustomiseMeinings = async (somedata) => {
    try {
      const data = {
        fromLang: videoInfo["subtitleOneLanguage"],
        toLang: videoInfo["subtitleTwoLanguage"],
        subtitle: subtitleOneContenet,
        translateOfSubtitle: subtitleTwoContenet,
        type: typeWord,
        // subtitleStartTime:"test",
        // subtitleEndTime:"test",
        movieName: videoInfo["filmName"],
        season: videoInfo["season"],
        episode: videoInfo["episode"],
        // groups:["tessdasdt","123"]
        ...somedata,
      };
      let res = await saveWordApi(data);
      if (res["data"] && res["data"]["success"]) {
        customToastify(
          "success",
          `${somedata["word"]} با موفقیت ذخیره شد`,
          200,
          "top-center"
        );
        let newUserWords = { ...userWords };
        newUserWords["userSavedWords"] = [
          ...userWords["userSavedWords"],
          somedata["word"].toLowerCase(),
        ];
        handleUserWords(newUserWords);
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify(
        "error",
        `مشکل در ذخیره ${somedata["word"]}:${
          errData["titles"] || errData["message"]
        }`,
        2000,
        "top-center"
      );
      console.error(error);
    }
  };

  const handleWord = (e) => {
    setWord(e.target.value);
  };

  const handleSaveButton = () => {
    if (fullscreen) {
      handleFullScreen.enter();
    }
    saveCustomiseMeinings({ meanings: [wordMeinings], word });
    handleOpenSaveAsWordsDialog(true);
    handlePlayingStatus(true, "closeDict");
    setWindowSize({ top: "25%", width: "50%", lines: 7, topLines: 1 });
  };

  const handleCancelButton = () => {
    if (fullscreen) {
      handleFullScreen.enter();
    }
    setWordMeinings("-");
    handleOpenSaveAsWordsDialog(true);
    handlePlayingStatus(true, "closeDict");
    setWindowSize({ top: "25%", width: "50%", lines: 7, topLines: 1 });
  };

  const editWordMeinings = (data) => {
    setWordMeinings(data);
  };

  const handleMeiningLines = (data) => {
    if (data) {
      let newdata = {};
      data.map((posmeaning, index) => {
        let str = posmeaning["pos"] == "noPos" ? "" : `${posmeaning["pos"]}:`;
        posmeaning["translations"].map((meining, idx) => {
          str += `${meining} ,`;
        });
        newdata[index] = str;
      });
      let oneItemData = "";
      Object.keys(newdata).forEach((line) => {
        oneItemData = oneItemData + "\n" + newdata[line];
      });
      setWordMeinings(oneItemData);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handleMeiningLines(dict);
    }, 100);
  }, [dict]);
  useEffect(() => {
    setWord(translateWord || []);
  }, [translateWord]);

  const handleDictOpen = (dict) => {
    if (dict == "Bamooz") {
      window.open(
        `https://dic.b-amooz.com/${videoInfo["subtitleOneLanguage"]}/dictionary/w?word=${word}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "Fastdic") {
      window.open(`https://fastdic.com/word/${word}`, "mozillaWindow", "popup");
    } else if (dict == "abadis") {
      window.open(`https://abadis.ir/entofa/${word}`, "mozillaWindow", "popup");
    } else if (dict == "bing") {
      window.open(
        `https://www.bing.com/translator/?from=${videoInfo["subtitleOneLanguage"]}&to=${videoInfo["subtitleTwoLanguage"]}&text=${word}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "cambridge") {
      window.open(
        `https://dictionary.cambridge.org/dictionary/english/${word}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "collins") {
      let dictUri = "";
      if (videoInfo["subtitleOneLanguage"] == "en")
        dictUri = `https://www.collinsdictionary.com/dictionary/english/${word}`;
      else if (videoInfo["subtitleOneLanguage"] == "de")
        dictUri = `https://www.collinsdictionary.com/dictionary/german-english/${word}`;
      else if (videoInfo["subtitleOneLanguage"] == "fr")
        dictUri = `https://www.collinsdictionary.com/dictionary/french-english/${word}`;
      else if (videoInfo["subtitleOneLanguage"] == "it")
        dictUri = `https://www.collinsdictionary.com/dictionary/italian-english/${word}`;
      window.open(dictUri, "mozillaWindow", "popup");
    } else if (dict == "glosbe") {
      window.open(
        `https://glosbe.com/${videoInfo["subtitleOneLanguage"]}/${videoInfo["subtitleTwoLanguage"]}/${word}`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "google") {
      window.open(
        `https://translate.google.com/?sl=${videoInfo["subtitleOneLanguage"]}&tl=${videoInfo["subtitleTwoLanguage"]}&text=${word}&op=translate`,
        "mozillaWindow",
        "popup"
      );
    } else if (dict == "deepl") {
      window.open(
        `https://www.deepl.com/en/translator#${videoInfo["subtitleOneLanguage"]}/en-us/${word}`,
        "mozillaWindow",
        "popup"
      );
    }
  };
  return (
    <>
      <Modal
        style={{
          top: windowSize["top"],
        }}
        width={windowSize["width"]}
        closable={false}
        getContainer={paperComponent}
        open={openSaveAsWordsDialog}
        footer={[
          <Button
            color="warning"
            sx={{ mx: 0.4, mb: 1 }}
            onClick={handleCancelButton}
            variant="contained"
            key={`CancelButton`}
          >
            لغو
          </Button>,
          <Button
            autoFocus
            sx={{ mb: 1 }}
            color="success"
            onClick={handleSaveButton}
            variant="contained"
            endIcon={<SaveIcon />}
            key={`SaveButton`}
          >
            ذخیره لغت
          </Button>,
        ]}
      >
        <Card sx={{ p: 0, m: 0 }}>
          <CardHeader
            sx={{ px: 0, py: 0 }}
            avatar={
              windowSize["lines"] == 7 ? (
                <OpenInFullIcon
                  color="warning"
                  sx={{ marginLeft: "10px", border: "1px solid" }}
                  onClick={() => {
                    setWindowSize({
                      top: "100px",
                      width: "100%",
                      lines: 15,
                      topLines: 3,
                    });
                  }}
                />
              ) : (
                <CloseFullscreenIcon
                  color="warning"
                  sx={{ marginLeft: "10px", border: "1px solid" }}
                  onClick={() => {
                    setWindowSize({
                      top: "25%",
                      width: "50%",
                      lines: 7,
                      topLines: 1,
                    });
                  }}
                />
              )
            }
            title={
              videoInfo["subtitleOneLanguage"] == "en" ? (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    // backgroundColor: "#b4b4f1",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      handleDictOpen("Bamooz");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="Bamooz"
                    color="primary"
                  >
                    <img src={Bamooz} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("Fastdic");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="Fastdic"
                    color="primary"
                  >
                    <img src={Fastdic} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("abadis");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="abadis"
                    color="primary"
                  >
                    <img src={abadis} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("bing");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="bing"
                    color="primary"
                  >
                    <img src={bing} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("cambridge");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="cambridge"
                    color="primary"
                  >
                    <img src={cambridge} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("collins");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="collins"
                    color="primary"
                  >
                    <img src={collins} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("glosbe");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="glosbe"
                    color="primary"
                  >
                    <img src={glosbe} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("google");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="google"
                    color="primary"
                  >
                    <img src={google} height={15} width={15} />
                  </IconButton>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    backgroundColor: "#b4b4f1",
                  }}
                >
                  {videoInfo["subtitleOneLanguage"] == "de" ||
                  videoInfo["subtitleOneLanguage"] == "tr" ||
                  videoInfo["subtitleOneLanguage"] == "fr" ? (
                    <IconButton
                      onClick={() => {
                        handleDictOpen("Bamooz");
                      }}
                      sx={{
                        border: "1px solid",
                        padding: "4px",
                        margin: "2px",
                      }}
                      aria-label="Bamooz"
                      color="primary"
                    >
                      <img src={Bamooz} height={15} width={15} />
                    </IconButton>
                  ) : null}
                  {videoInfo["subtitleOneLanguage"] !== "tr" ? (
                    <IconButton
                      onClick={() => {
                        handleDictOpen("collins");
                      }}
                      sx={{
                        border: "1px solid",
                        padding: "4px",
                        margin: "2px",
                      }}
                      aria-label="collins"
                      color="primary"
                    >
                      <img src={collins} height={15} width={15} />
                    </IconButton>
                  ) : null}

                  <IconButton
                    onClick={() => {
                      handleDictOpen("deepl");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="deepl"
                    color="primary"
                  >
                    <img src={deepl} height={15} width={15} />
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      handleDictOpen("glosbe");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="glosbe"
                    color="primary"
                  >
                    <img src={glosbe} height={15} width={15} />
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      handleDictOpen("google");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="google"
                    color="primary"
                  >
                    <img src={google} height={15} width={15} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleDictOpen("bing");
                    }}
                    sx={{ border: "1px solid", padding: "4px", margin: "2px" }}
                    aria-label="bing"
                    color="primary"
                  >
                    <img src={bing} height={15} width={15} />
                  </IconButton>
                </Box>
              )
            }
          />

          <Divider />
          <TextField
            hiddenLabel
            id="filled-hidden-label-small"
            value={word}
            multiline
            rows={windowSize["topLines"]}
            onChange={handleWord}
            variant="filled"
            size="small"
            sx={{ p: 0, m: 0, width: "95%" }}
          />

          <TextField
            id="outlined-multiline-static"
            label="ترجمه و توضیحات بیشتر (برای ذخیره)"
            sx={{ width: "95%", marginTop: "8px" }}
            multiline
            value={wordMeinings}
            rows={windowSize["lines"]}
            onChange={(e) => {
              editWordMeinings(e.target.value);
            }}
          />
          {enDataDict && enDataDict.length > 0 ? (
            <AccordianData enDataDict={enDataDict} />
          ) : null}
        </Card>
        <Checkbox
          sx={{ m: 0, p: 0 }}
          checked={fullscreen}
          onChange={(event) => {
            setFullscreen(!fullscreen);
          }}
        />
        <Typography
          sx={{ px: 2 }}
          color="text.primary"
          display="contents"
          variant="caption"
        >
          ادامه فیلم بصورت تمام صفحه
        </Typography>
      </Modal>
    </>
  );
};
export default SaveAsWordsDialog;
